import { PositiveColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { CENTERED_CONTENT_MAX_WIDTH, LOGO_DIMENSIONS, LOGO_MIN_WIDTH } from './constants';

type StyeleProps = {
  gridColumns?: number;
  hasMinimumLogosCount?: boolean;
  width?: number | string;
  height?: number | string;
  isPartnershipVariant?: boolean;
};

const useStyles = createUseStyles<string, StyeleProps>(
  () => ({
    root: {
      overflow: 'hidden',
      padding: [Spacings.s64, Spacings.s0],
      margin: 'auto',
      [BreakPointsMedia.LG]: {
        padding: [Spacings.s40, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: ({ gridColumns }) =>
        `repeat(${gridColumns}, minmax(138px, ${LOGO_DIMENSIONS.width}px))`,
      gridTemplateRows: LOGO_DIMENSIONS.height,
      gridGap: props => (props.gridColumns === 5 ? 112 : Spacings.s72),
      marginTop: Spacings.s24,
      margin: props => (props.hasMinimumLogosCount ? 'auto' : 'inherit'),
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        marginTop: Spacings.s0,
        gridTemplateRows: LOGO_DIMENSIONS.height / 2,
        gridGap: props => (props.gridColumns === 5 ? Spacings.s32 : Spacings.s44),
      },
    },
    centeredContent: {
      maxWidth: props => (props.hasMinimumLogosCount ? 1000 : CENTERED_CONTENT_MAX_WIDTH),
      marginTop: Spacings.s24,
      [BreakPointsMedia.MD]: {
        overflow: 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
    title: {
      width: 'fit-content',
      minWidth: 200,
      margin: [Spacings.s0, 'auto'],
      fontSize: FontSizes.s36,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l48,
      color: PositiveColors.text.default,

      [BreakPointsMedia.LG]: {
        margin: [Spacings.s0, 'auto', Spacings.s32],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '-webkit-line-clamp': 3,
        margin: [Spacings.s0, 'auto', Spacings.s24],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 4,
        margin: [Spacings.s0, 'auto', Spacings.s12],
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },

    skeletonGrid: {
      display: 'flex',
      gap: Spacings.s40,
      marginTop: 80,
    },

    skeletonItem: {
      borderRadius: CornerRadius.r8,
      minHeight: 50,
      minWidth: LOGO_MIN_WIDTH,
    },

    skeletonTitle: {
      extend: 'title',
      height: Spacings.s40,
    },
  }),
  {
    name: 'inThePress',
  },
);

export default useStyles;
